import { getData } from 'src/utils/axios';
import { urlMap } from 'src/utils/urls';

export const getQuestionTypes = async () =>
  getData(urlMap.questions.types);

export const getQuestionsById = async (questionId) =>
   getData(urlMap.questions.byId.replace(':questionId', questionId))

